// Product End Points
export const product = {
  getProducts: "/api/product/getProducts",
  createProduct: "/api/product/createProduct",
  updateProduct: "/api/product/updateProduct",
  deleteProduct: "/api/product/deleteProduct",
};

//Product Type End Points
export const productType = {
  getProductTypes: "/api/productType/getProductTypes",
  getMovingHistory: "/api/productType/getMovingHistory",
  createProductType: "/api/productType/createProductType",
  updateProductType: "/api/productType/updateProductType",
  updatePairsByUniqueStockID: "/api/productType/updatePairsByUniqueStockID",
  deleteProductType: "/api/productType/deleteProductType",
  deleteDirectEntryProductType: "/api/productType/deleteDirectEntryProductType",
};

//Product Type With Out HUIDEnd Points
export const productTypeWithOutHUID = {
  getProductTypeWithOutHUIDs:
    "/api/productTypeWithOutHUID/getProductTypeWithOutHUIDs",
  createProductTypeWithOutHUID:
    "/api/productTypeWithOutHUID/createProductTypeWithOutHUID",

  createProductTypeWithOutHUIDTransactions:
    "/api/productTypeWithOutHUID/createProductTypeWithOutHUIDTransactions",

  updateProductTypeWithOutHUID:
    "/api/productTypeWithOutHUID/updateProductTypeWithOutHUID",

  moveProductType: "/api/productTypeWithOutHUID/moveProductType",

  deleteProductTypeWithOutHUID:
    "/api/productTypeWithOutHUID/deleteProductTypeWithOutHUID",

  createHUID: "/api/productTypeWithOutHUID/createHUID",

  getHUID: "/api/productTypeWithOutHUID/getHUID",

  deleteHUID: "/api/productTypeWithOutHUID/deleteHUID",
};

//Customer End Points
export const customer = {
  getCustomers: "/api/customer/getCustomers",
  createCustomer: "/api/customer/createCustomer",
  updateCustomer: "/api/customer/updateCustomer",
  deleteCustomer: "/api/customer/deleteCustomer",
};

//User End Points
export const user = {
  getUsers: "/api/user/getUsers",
  createUser: "/api/user/createUser",
  updateUser: "/api/user/updateUser",
  deleteUser: "/api/user/deleteUser",
};

//User End Points
export const order = {
  getOrders: "/api/order/getOrders",
  getOrderProducts: "/api/order/getOrderProducts",
  createOrder: "/api/order/createOrder",
  createOrderProduct: "/api/order/createOrderProduct",
  updateOrder: "/api/order/updateOrder",
  updateOrderProduct: "/api/order/updateOrderProduct",
  deleteOrder: "/api/order/deleteOrder",
  deleteOrderProduct: "/api/order/deleteOrderProduct",
  checkHUIDStocks: "/api/order/checkHUIDStocks",
  updateStocksByHUID: "/api/order/updateStocksByHUID",
};

//User End Points
export const personalDetail = {
  getPersonalDetails: "/api/personalDetails/getPersonalDetails",
  createPersonalDetails: "/api/personalDetails/createPersonalDetails",
  updatePersonalDetails: "/api/personalDetails/updatePersonalDetails",
  deletePersonalDetails: "/api/personalDetails/deletePersonalDetails",
};

//Reports End Points
export const reports = {
  getOrderReports: "/api/reports/getOrderReports",
};

//Ledgers End Points
export const ledgers = {
  getLedgers: "/api/ledger/getLedgers",
  getLedgersByCustomerID: "/api/ledger/getLedgersByCustomerID",
  createLedger: "/api/ledger/createLedger",
  updateLedger: "/api/ledger/updateLedger",
  deleteLedger: "/api/ledger/deleteLedger",
};

//export const baseURL = process.env.BASEURL;
export const baseURL = "https://vijay.moiaccount.in";
